import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/immediate-extraction' },
  {
    path: '/extract-home-page',
    name: 'extractHomePage',
    component: () => import('../views/extractHomePage.vue')
  },
  {
    path: '/immediate-extraction',
    name: 'immediateExtraction',
    component: () => import('../views/immediateExtraction.vue')
  },
  {
    path: '/frame-selection',
    name: 'frameSelection',
    component: () => import('../views/frameSelection.vue')
  },
  {
    path: '/avatar-making',
    name: 'avatarMaking',
    component: () => import('../views/avatarMaking.vue')
  },
  {
    path: '/avatar-sharing',
    name: 'avatarSharing',
    component: () => import('../views/avatarSharing.vue')
  }
  ,
  {
    path: '/dome',
    name: 'dome',
    component: () => import('../views/Dome.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


export default router
